import SettingEnv from '../setting'
import { Base64 } from 'js-base64';


export function createPreView(url,attachmentName) {
    const previewEnvUrl = SettingEnv.previewUrl
    let preViewUrl = url + '&fullfilename=/' + attachmentName
    return previewEnvUrl+encodeURIComponent(Base64.encode(preViewUrl));
}
